import { Action, createReducer, on } from '@ngrx/store';
import { AuthState } from '@rci/self-serve-fido/state/auth/auth.state';
import * as fromActions from './auth.actions';

const initialState: AuthState = {
  guid: '',
};

const createAuthStateReducer = createReducer(
  initialState,
  on(fromActions.resetAuthState, _state => ({ ...initialState })),
  on(fromActions.updateAuthState, (state, { guid }) => ({
    ...state,
    guid,
  })),
);

// eslint-disable-next-line
export function authStateReducer(state: AuthState, action: Action) {
  return createAuthStateReducer(state, action);
}
